import React from 'react';
import { SurveyQuestion } from '../../../config/surveys/schema';

interface SidebarQuestionItemProps {
  question: SurveyQuestion;
  questionNumber: number;
  sectionIndex: number;
  isCurrent: boolean;
  isAnswered: boolean;
  isAccessible: boolean;
  onClick: () => void;
}

const SidebarQuestionItem: React.FC<SidebarQuestionItemProps> = ({
  question,
  questionNumber,
  isCurrent,
  isAnswered,
  isAccessible,
  onClick,
}) => {
  const truncateText = (text: string, maxLength: number = 45): string => {
    if (text.length <= maxLength) return text;
    return text.substring(0, maxLength).trim() + '...';
  };

  const getStatusClass = (): string => {
    if (isCurrent) return 'current';
    if (isAnswered) return 'answered';
    if (isAccessible) return 'accessible';
    return 'locked';
  };

  const handleClick = () => {
    if (isAccessible || isAnswered || isCurrent) {
      onClick();
    }
  };

  return (
    <button
      className={`sidebar-question-item ${getStatusClass()}`}
      onClick={handleClick}
      disabled={!isAccessible && !isAnswered && !isCurrent}
      title={question.text}
    >
      <span className="question-indicator">
        {isAnswered && !isCurrent ? '✓' : questionNumber}
      </span>
      <span className="question-text">{truncateText(question.text)}</span>
    </button>
  );
};

export default SidebarQuestionItem;
